module.exports = __webpack_public_path__ + "b1277a494a1e812b0de1b765a8415f88.png";